import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
    //

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
        </Helmet>
    );
};

Meta.defaultProps = {
    title: 'Bienvenido a HomeSanty',
    description: 'Todo lo que necesitas, en un solo lugar y al mejor precio!',
    keywords:
        'hogar, decoracion, cocina, envios a todo el pais, descuentos, economico, cuenca, ecuador, comercio, electronico',
};

export default Meta;
